(function () {
  'use strict';

  function numberFrom(input) {
    var value = Number.parseFloat(input && input.value);
    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function calculateFeeBay(salePrice, shippingCost, itemCost, feeRate) {
    var rate = Math.max(0, feeRate) / 100;
    var fee = salePrice * rate;
    var net = salePrice - fee - shippingCost - itemCost;
    var margin = salePrice > 0 ? (net / salePrice) * 100 : 0;
    var breakEven = rate < 1 ? (shippingCost + itemCost) / (1 - rate) : 0;

    return {
      gross: salePrice,
      fee: fee,
      shipping: shippingCost,
      cost: itemCost,
      net: net,
      margin: margin,
      breakEven: breakEven
    };
  }

  function initialize(root) {
    if (!root || root.dataset.feebayReady === 'true') return;
    root.dataset.feebayReady = 'true';

    var saleInput = root.querySelector('[data-feebay-sale-price]');
    var shippingInput = root.querySelector('[data-feebay-shipping-cost]');
    var itemInput = root.querySelector('[data-feebay-item-cost]');
    var rateButtons = Array.prototype.slice.call(root.querySelectorAll('[data-feebay-rate]'));
    var advancedLinks = Array.prototype.slice.call(root.querySelectorAll('[data-feebay-advanced-link]'));
    var shareButton = root.querySelector('[data-feebay-share]');
    var currentRate = Number.parseFloat(root.dataset.initialRate) || 0;
    var currency = root.dataset.currency || 'USD';
    var formatter;

    try {
      formatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (error) {
      formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function money(value) {
      return formatter.format(Math.abs(value));
    }

    function setText(selector, value) {
      var element = root.querySelector(selector);
      if (element) element.textContent = value;
    }

    function update() {
      var result = calculateFeeBay(
        numberFrom(saleInput),
        numberFrom(shippingInput),
        numberFrom(itemInput),
        currentRate
      );
      var netLabel = (result.net < 0 ? '−' : '') + money(result.net);
      var netElement = root.querySelector('[data-feebay-net]');
      var marginElement = root.querySelector('[data-feebay-margin]');
      var mobileResult = root.querySelector('[data-feebay-mobile-result]');

      setText('[data-feebay-net]', netLabel);
      setText('[data-feebay-mobile-net]', netLabel);
      setText('[data-feebay-gross]', money(result.gross));
      setText('[data-feebay-fee]', '−' + money(result.fee));
      setText('[data-feebay-shipping]', '−' + money(result.shipping));
      setText('[data-feebay-cost]', '−' + money(result.cost));
      setText('[data-feebay-break-even]', money(result.breakEven));
      setText('[data-feebay-rate-label]', '(' + currentRate.toFixed(2).replace(/\.00$/, '') + '%)');
      setText('[data-feebay-margin]', result.margin.toFixed(1).replace(/\.0$/, '') + '% margin');

      if (netElement) netElement.classList.toggle('is-negative', result.net < 0);
      if (marginElement) marginElement.classList.toggle('is-negative', result.margin < 0);
      if (mobileResult) {
        var shouldShow = result.gross > 0;
        mobileResult.classList.toggle('is-visible', shouldShow);
        mobileResult.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }
    }

    [saleInput, shippingInput, itemInput].forEach(function (input) {
      if (input) input.addEventListener('input', update);
    });

    rateButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        currentRate = Number.parseFloat(button.dataset.feebayRate) || 0;
        rateButtons.forEach(function (candidate) {
          var active = candidate === button;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        update();
      });
    });

    advancedLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        try {
          window.sessionStorage.setItem('feebayQuickTransfer', JSON.stringify({
            salePrice: numberFrom(saleInput),
            shippingCost: numberFrom(shippingInput),
            itemCost: numberFrom(itemInput),
            feeRate: currentRate
          }));
        } catch (error) {
          // The calculator still opens when storage is unavailable.
        }
      });
    });

    if (shareButton) {
      var shareLabel = shareButton.querySelector('[data-feebay-share-label]');
      var defaultShareLabel = shareLabel ? shareLabel.textContent : 'Share calculator';

      function copyShareLink(url) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(url);
        }

        return new Promise(function (resolve, reject) {
          var temporary = document.createElement('textarea');
          temporary.value = url;
          temporary.setAttribute('readonly', '');
          temporary.style.position = 'fixed';
          temporary.style.opacity = '0';
          document.body.appendChild(temporary);
          temporary.select();
          var copied = document.execCommand('copy');
          document.body.removeChild(temporary);
          copied ? resolve() : reject(new Error('Copy failed'));
        });
      }

      function showShareStatus(message) {
        if (!shareLabel) return;
        shareLabel.textContent = message;
        window.setTimeout(function () { shareLabel.textContent = defaultShareLabel; }, 2200);
      }

      shareButton.addEventListener('click', function () {
        var shareUrl = root.dataset.shareUrl || window.location.href.split('#')[0];
        var shareData = {
          title: root.dataset.shareTitle || document.title,
          text: root.dataset.shareText || '',
          url: shareUrl
        };

        shareButton.disabled = true;
        var action;

        if (navigator.share) {
          action = navigator.share(shareData).then(function () {
            showShareStatus('Shared!');
          }).catch(function (error) {
            if (error && error.name === 'AbortError') return;
            return copyShareLink(shareUrl).then(function () { showShareStatus('Link copied!'); });
          });
        } else {
          action = copyShareLink(shareUrl).then(function () { showShareStatus('Link copied!'); });
        }

        Promise.resolve(action).catch(function () {
          showShareStatus('Copy the page URL');
        }).then(function () {
          shareButton.disabled = false;
        });
      });
    }

    update();
  }

  function initializeAll(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-feebay-calculator]'),
      initialize
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
    if (event.target.matches && event.target.matches('[data-feebay-calculator]')) initialize(event.target);
  });

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { calculateFeeBay: calculateFeeBay };
  }
})();
